import { object, string } from 'yup';

export const VoucherPageFormValidation = object().shape({
  code: string().min(3).required(),
});
